import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useReactToPrint } from "react-to-print";
import logo from '../components/Reports/food.jpeg';

const InviteCustomer = forwardRef((props, ref) => {
  const [inviteModal, setInviteModal] = useState(false);
  const [items, setItems] = useState({}) 

  useEffect(() => {
    if(props.data)
   { setItems(props.data);}
  }, [props.data ,setItems]);
console.log("items",items)
  const componentRef = useRef();

  useImperativeHandle(ref, () => ({
    showInviteModal() {
      setInviteModal(true);
    }
  }));

  const generatePDF = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF")
  });

  const printInvoice = () => {
    window.print();
  };
  function numberToArabicWords(num) {
    const units = ["", "واحد", "اثنان", "ثلاثة", "أربعة", "خمسة", "ستة", "سبعة", "ثمانية", "تسعة"];
    const tens = ["", "عشرة", "عشرون", "ثلاثون", "أربعون", "خمسون", "ستون", "سبعون", "ثمانون", "تسعون"];
    const hundreds = ["", "مئة", "مئتان", "ثلاثمائة", "أربعمائة", "خمسمائة", "ستمائة", "سبعمائة", "ثمانمائة", "تسعمائة"];
    const thousands = ["", "ألف", "ألفان", "ثلاثة آلاف", "أربعة آلاف", "خمسة آلاف", "ستة آلاف", "سبعة آلاف", "ثمانية آلاف", "تسعة آلاف"];

    if (num === 0) return "صفر";
    if (num < 0 || num > 9999) return "العدد خارج النطاق";

    let arabicWords = "";

    // Extract each digit
    const thousandsPlace = Math.floor(num / 1000);
    const hundredsPlace = Math.floor((num % 1000) / 100);
    const tensPlace = Math.floor((num % 100) / 10);
    const unitsPlace = num % 10;

    // Thousands
    if (thousandsPlace > 0) {
        arabicWords += thousands[thousandsPlace] + " ";
    }

    // Hundreds
    if (hundredsPlace > 0) {
        arabicWords += hundreds[hundredsPlace] + " ";
    }

    // Tens and Units
    if (tensPlace > 1) {
        arabicWords += units[unitsPlace] + (unitsPlace > 0 ? " و" : "") + tens[tensPlace];
    } else if (tensPlace === 1) {
        arabicWords += unitsPlace === 0 ? tens[1] : (units[unitsPlace] + " عشر");
    } else {
        arabicWords += units[unitsPlace];
    }

    return arabicWords.trim();
}
// Example usage:
console.log(numberToArabicWords(1001)); // Output: ألف و واحد
console.log(numberToArabicWords(2020)); // Output: ألفان و عشرون
console.log(numberToArabicWords(12345)); // Output: اثنا عشر ألفا و ثلاثمائة و خمسة و أربعون


// Example usage:
console.log(numberToArabicWords(23)); // Output: ثلاثة و عشرون


  const [company, setcompany] = useState([]);
console.log(numberToArabicWords(200)); // Output: مئتان
useEffect(() => {
  const companydata = localStorage.getItem('companies');
  if (companydata) {
    const parsedData = JSON.parse(companydata);
    const singleCompany = Array.isArray(parsedData) ? parsedData[0] : parsedData;
    setcompany(singleCompany); // Set state to a single object
  }
}, []);
  return (
    <>
      <Modal className="modal fade " size=' xl' id="exampleModal1" show={inviteModal} onHide={() => setInviteModal(false)} centered>
        <div className="modal-content">
          <div ref={componentRef} className="modal-body" dir="rtl">
          {/* <div className="row">
                    <div className="col-xl-12 text-center row">
                    <div  style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      }}>  <div 
    style={{
      fontSize: '24px',
      fontWeight: 'bold'
    }}>
                    <div className="d-flex"><h2 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold'}}>{company.CompanyName}</h2> </div>
                   <div className="d-flex"> <h2 style={{fontFamily: 'SC_AMEEN',color:'#003b53',fontWeight:'lighter',  marginRight: '-15px'}}>{company.Description}</h2>  </div>
                   <div className="d-flex">                    <i class="fa-solid fa-location-dot pt-1 ps-2" style={{color:'#8e2927'}}></i>
                    <h2 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold' ,fontSize:'14px'}}> {company.Address}</h2> <i class="fa-solid fa-phone-flip p-1 px-2" style={{color:'#8e2927'}}></i><h5 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold' ,fontSize:'14px'}}>{company.ContactNumber}</h5></div>
</div> 

 <img src={`https://subk.education.com.ly/back${company.ImageName}`} alt="Logo" style={{ height: "150px", width: "200px",  marginTop: '-10px',  marginLeft: '-30px' }} />

                     </div>
                  </div> 
                  </div> 
             */}
            <div style={{ width: '100%' }} className="table-responsive">
              <table className="table table-bordered verticle-middle table-responsive-sm" style={{ borderCollapse: "unset", borderWidth: '1 px' }}>
                <tbody>
                  <tr>
                    <td style={{ boxShadow: '0 1px 1px 0 black' , border: '1px solid #ccc' }}>رقم الايصال :{items.reference_number}</td>
                    <td style={{ boxShadow: '0 1px 1px 0 black',border: '1px solid #ccc' }}> </td>
                  </tr>
                  <tr>
                    <td style={{ boxShadow: '0 1px 1px 0 black',border: '1px solid #ccc' }}>استلمت من: {items.CustomerName}</td>
                    <td style={{ boxShadow: '0 1px 1px 0 black' ,border: '1px solid #ccc'}}>بتاريخ: {items.IssueDate}</td>
                  </tr>
                  <tr>
                    <td style={{ boxShadow: '0 1px 1px 0 black' ,border: '1px solid #ccc'}}>مبلغ مالي بقيمة: {items.AmountDue}</td>
                    <td style={{ boxShadow: '0 1px 1px 0 black' ,border: '1px solid #ccc',verticalAlign:'top'}} rowspan="2"> ودلك لي :{items.PaymentStatus} </td>
                  </tr>
                  <tr >
                    <td style={{ boxShadow: '0 1px 1px 0 black' ,border: '1px solid #ccc'}}>المبلغ المتبقي: {items.RestAmount}</td>
                  </tr>
                  <tr >
                    <td style={{ boxShadow: '0 1px 1px 0 black'  ,border: '1px solid #ccc'}} colSpan="2" >المبلغ بالحروف :{ numberToArabicWords(items.AmountDue)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-danger light" onClick={() => setInviteModal(false)}>إلغاء</button>
             <button className="btn btn-success" onClick={generatePDF}>طباعه</button>
          </div>
        </div>
      </Modal>
    </>
  );
});

export default InviteCustomer;
